import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { actions as virtualEventsActions } from '../../../Reducks/VirtualEvents';
import { connect } from 'react-redux';
import { MAX_RANGE, MIN_RANGE } from '../../../Utils/Constants';
import { ResponsiveModal } from '@getgo/chameleon-react';
import { Button, Popover, PopoverBody } from 'reactstrap';
import RangeSelectorComponent from '../../../Components/RangeSelector/RangeSelectorComponent';
import FilterButton from '../../../Components/FilterButton/FilterButton';
import './VirtualEventsRangeFilter.css';
import { isArrayEqual } from '../../../Utils/ArrayUtils';

export class VirtualEventsRangeFilter extends Component {
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    uniqueId: PropTypes.string.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    reduced_virtual_events: PropTypes.object,
    filterVirtualEventsByCount: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      isRangeFilterOpen: false,
      registrantRange: [MIN_RANGE, MAX_RANGE],
      isRegistrantRangeValid: true,
      resetValid: false
    };
  }

  updateRegistrantRange = registrantRange => {
    this.setState({ registrantRange });
  };

  setRegistrantRangeValidity = isRegistrantRangeValid => {
    this.setState({ isRegistrantRangeValid });
  };

  componentDidMount() {
    const { registrantRange } = this.props.reduced_virtual_events.filter;

    if (!isArrayEqual(registrantRange, this.state.registrantRange)) {
      this.setState({
        registrantRange
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { registrantRange } = this.props.reduced_virtual_events.filter;

    if (!isArrayEqual(registrantRange, prevProps.reduced_virtual_events.filter.registrantRange)) {
      this.setState({
        registrantRange
      });
    }
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  toggleRangeFilter = () => {
    if (!this.state.resetValid) {
      this.setState({
        registrantRange: this.props.reduced_virtual_events.filter.registrantRange
      });
    }
    this.setState(prevState => ({
      isRangeFilterOpen: !prevState.isRangeFilterOpen
    }));
  };

  render() {
    const { isBig } = this.props;
    const { virtualEvents, filter } = this.props.reduced_virtual_events;
    let filterDisabled =
      virtualEvents &&
      ((virtualEvents.allKeys && virtualEvents.allKeys.length === 0) || this.props.reduced_virtual_events.fetching);
    let virtualEventsRangeFilterCount = this.getVirtualEventsRangeFilterCount(filter);

    return (
      <div id={this.props.uniqueId}>
        <FilterButton
          isBig={isBig}
          rangeFilterCount={virtualEventsRangeFilterCount}
          filterDisabled={filterDisabled}
          onClick={this.toggleRangeFilter}
        />
        {isBig ? this.getDefaultRender() : this.getMobileRender()}
      </div>
    );
  }

  getMobileRender = () => {
    return (
      <ResponsiveModal isOpen={this.state.isRangeFilterOpen} onClose={() => this.setResetValidity(false)}>
        <div className="virtualEventsRangeFilterMobile">{this.getFilters()}</div>
      </ResponsiveModal>
    );
  };

  getDefaultRender = () => {
    return (
      <Popover
        className="virtualEventsRangeFilterPopover"
        isOpen={this.state.isRangeFilterOpen}
        placement="bottom"
        target={this.props.uniqueId}
        toggle={this.toggleRangeFilter}
        hideArrow={true}>
        <PopoverBody>
          <div>{this.getFilters(true)}</div>
        </PopoverBody>
      </Popover>
    );
  };

  getVirtualEventsRangeFilterCount = virtualEventsFilter => {
    let virtualEventsRangeFilterCount = 0;
    if (!isArrayEqual(virtualEventsFilter.registrantRange, [MIN_RANGE, MAX_RANGE])) {
      virtualEventsRangeFilterCount += 1;
    }
    return virtualEventsRangeFilterCount;
  };

  getFilters = () => {
    const { t } = this.context;
    return (
      <div>
        <div className="filterHeading">
          <div className="filterTitle">{t('buttons.filter')}</div>
          <div className="filterDescription">{t('sessions.filter.filterTitle')}</div>
          <hr />
        </div>

        <div className="filterBody">
          <RangeSelectorComponent
            sectionTitle={t('sessions.filter.numberOfRegistrants')}
            range={this.state.registrantRange}
            updateRange={this.updateRegistrantRange}
            className={'Registrants'}
            MIN_RANGE={MIN_RANGE}
            MAX_RANGE={MAX_RANGE}
            setValidity={this.setRegistrantRangeValidity}
          />
        </div>
        <div className="filterSubmissionSection">
          {this.resetButton()}
          <div className="applyAndCancel">
            {this.cancelButton()}
            {this.applyButton(false)}
          </div>
        </div>
      </div>
    );
  };

  static isResetDisabled(registrantRange) {
    return MIN_RANGE === registrantRange[0] && MAX_RANGE === registrantRange[1];
  }

  resetButton = () => {
    let { registrantRange } = this.state;
    const { t } = this.context;
    return (
      <Button
        className="resetButton"
        color="link"
        disabled={VirtualEventsRangeFilter.isResetDisabled(registrantRange)}
        onClick={this.reset}>
        {t('buttons.reset')}
      </Button>
    );
  };

  cancelButton = () => {
    const { t } = this.context;
    return (
      <Button onClick={() => this.setResetValidity(false)} color="link">
        {t('buttons.cancel')}
      </Button>
    );
  };

  applyButton = () => {
    let isInvalid = !this.state.isRegistrantRangeValid;
    let { registrantRange } = this.props.reduced_virtual_events.filter;

    let isDisabled = isInvalid || isArrayEqual(this.state.registrantRange, registrantRange);
    const { t } = this.context;
    return (
      <Button className="applyButton" disabled={isDisabled} onClick={this.applyFilter} color={'link'}>
        {t('buttons.apply')}
      </Button>
    );
  };

  setResetValidity = isValid => {
    this.setState(
      {
        resetValid: isValid
      },
      function() {
        this.toggleRangeFilter();
      }
    );
  };
  applyFilter = () => {
    const filterOptions = {
      registrantRange: this.state.registrantRange
    };
    this.props.filterVirtualEventsByCount(filterOptions);
    this.setResetValidity(true);
  };

  reset = () => {
    const registrantRange = [MIN_RANGE, MAX_RANGE];
    this.setState({
      registrantRange,
      isRegistrantRangeValid: true,
      isAttendeeRangeValid: true,
      resetValid: false
    });
  };
}

export default connect(
  state => ({
    reduced_virtual_events: state.reduced_virtual_events
  }),
  {
    filterVirtualEventsByCount: virtualEventsActions.filterVirtualEvents
  }
)(VirtualEventsRangeFilter);



// WEBPACK FOOTER //
// ./src/GoToWebinar/VirtualEvents/Filters/VirtualEventsRangeFilter.js